@if (sichtbar()) {
  <section class="ki-mcp-block" data-testid="ki-mcp-block" aria-labelledby="ki-mcp-block-titel">
    <div class="ki-mcp-block__kopf">
      <app-ki-mark [size]="28" />
      <div class="ki-mcp-block__text">
        <h2 id="ki-mcp-block-titel" class="ki-mcp-block__titel">{{ 'ki.mcp.titel' | translate }}</h2>
        <p class="ki-mcp-block__untertitel">{{ 'ki.mcp.untertitel' | translate }}</p>
      </div>
    </div>

    <div class="ki-mcp-block__adresse-zeile">
      <span class="ki-mcp-block__adresse-label">{{ 'ki.mcp.serverAdresse' | translate }}</span>
      <code class="ki-mcp-block__adresse">{{ serverAdresse }}</code>
    </div>

    <div class="ki-mcp-block__code-huelle">
      <pre class="ki-mcp-block__code">{{ snippet }}</pre>
      <button type="button" class="ki-mcp-block__kopieren" data-testid="ki-mcp-kopieren" (click)="kopieren()">
        <span aria-live="polite">
          @if (kopiert()) {
            <span aria-hidden="true">✓</span>
            {{ 'ki.mcp.kopiert' | translate }}
          } @else {
            {{ 'ki.mcp.kopieren' | translate }}
          }
        </span>
      </button>
    </div>
  </section>
}
